<template>
    <div class="tab-content-container">
        <!--    Contacts    -->
        <div class="tab-header-container">
            <h2 class="form-label">Контакти</h2>
            <LiteButton @click.native="addContact"
                        class="edit-button"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <!-- One Contact -->
        <div class="item-container very-light-shadow"
             style="padding-bottom: 0;"
             v-for="contact in workerContacts" :key="contact.id">
            <LiteButton @click.native="editContact(contact)"
                        class="edit-button"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getLastModifiedDate(contact)"></p>
                <p class="last-modified-name" v-text="getLastModifiedBy(contact)"></p>
            </div>
            <div class="form-container">
                <div class="form-column-container">
                    <TextField class="text-field"
                               :value="getContactName(contact)"
                               :label="'Име'"/>
                    <TextField class="text-field"
                               :value="contact.relationDescription"
                               :label="'Връзка'"/>
                    <TextField class="text-field"
                               :value="formatDate(contact.birthDate)"
                               :label="'Дата на раждане'"/>
                    <TextField class="text-field"
                               :value="hasSupport(contact)"
                               :label="'Издръжка'"/>
                </div>
                <div class="form-column-container">
                    <TextField class="text-field"
                               :value="contact.email"
                               :label="'Е-Мейл'"/>
                    <TextField class="text-field"
                               :value="contact.phoneNumber"
                               :label="'Телефон'"/>
                    <TextField class="text-field"
                               :value="contact.address"
                               :label="'Адрес'"/>
                </div>
            </div>
        </div>

        <!-- Edit/Add contact -->
        <WorkerContactEditForm class="popup-shadow" v-if="shouldEdit" :contact="currentEditedContact" @close-clicked="closeEdit" />
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import mapperService from "@/services/mapper.service";
    import LiteButton from "@/shared/components/button/LiteButton"
    import TextField from "@/shared/components/TextField";
    import WorkerContactEditForm from "@/components/worker/form/WorkerContactEditForm";
    import {cloneDeep} from 'lodash';
    import dateService from "@/services/date.service";
    import utilService from "@/services/util.service";

    export default {
        name: "WorkerContactInfo",
        components: {WorkerContactEditForm, TextField, LiteButton},
        created() {
            this.workerContacts = cloneDeep(this.contacts);
        },
        data() {
            return {
                workerId: this.$route.params.id,
                workerContacts: cloneDeep(this.contacts),
                shouldEdit: false,
                currentEditedContact: null
            }
        },
        methods: {
            getLastModifiedBy(contact) {
                return mapperService.getLastModifiedBy(contact);
            },
            getLastModifiedDate(contact) {
                return mapperService.getLastModifiedDate(contact);
            },
            getContactName(contact) {
                const firstName = contact.firstName ? contact.firstName : '';
                const middleName = contact.middleName ? contact.middleName : '';
                const lastName = contact.lastName ? contact.lastName : '';
                return firstName + ' ' + middleName + ' ' + lastName;
            },
            formatDate(date) {
                if (date) {
                    return dateService.formatDate(date);
                }
                return '';
            },
            addContact() {
                this.currentEditedContact = {};
                this.currentEditedContact.workerId = this.workerId;
                this.$store.commit('setHasModal', true);
                this.shouldEdit = true;
            },
            editContact(contact) {
                this.currentEditedContact = contact;
                this.currentEditedContact.workerId = this.workerId;
                this.$store.commit('setHasModal', true);
                this.shouldEdit = true;
            },
            closeEdit() {
                this.currentEditedContact = null;
                this.$store.commit('setHasModal', false);
                this.shouldEdit = false;
            },
            hasSupport(contact) {
                return contact.support ? 'Да' : 'Не';
            }
        },
        computed: {
            ...mapGetters(['contacts'])
        },
        watch: {
            contacts: {
                handler(newVal) {
                    if (newVal) {
                        this.workerContacts = cloneDeep(newVal);
                        this.workerContacts = utilService.sortArrayByDateSelector(this.workerContacts, 'lastModifiedDate', true);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .form-container {
        width: 100%;
        height: fit-content;
        display: inline-block;
    }

    .form-column-container {
        width: 50%;
        padding: 20px 140px;
        margin: 0 auto;
        display: inline-grid;
        height: fit-content;
        box-sizing: border-box;
    }
</style>
